import { combineReducers } from 'redux';
import { head, get } from 'lodash';
import { RECALL } from '../actions/types';
import { isLoadingReducer } from './helpers';

const data = (state = null, action) => {
  switch (action.type) {
    case RECALL.REQUEST: {
      return null;
    }
    case RECALL.SUCCESS: {
      const { response } = action.payload;
      return get(response, 'recall', {});
    }
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case RECALL.REQUEST:
    case RECALL.SUCCESS:
      return null;
    case RECALL.FAILURE:
      return {
        error: get(action, 'error', true)
      };
    default:
      return state;
  }
};

const isFething = isLoadingReducer(RECALL);

export default combineReducers({ data, isFething, error });



// WEBPACK FOOTER //
// ./src/reducers/recall.js